import { ReactElement } from 'react';
import ExerciseCategoryManagement from '../../../components/exerciseCategory/ExerciseCategoryManagement';

const AdminExerciseCategories = (): ReactElement => {
  return (
    <ExerciseCategoryManagement mode="admin" />
  )
}

export default AdminExerciseCategories